<template>
  <v-row>
    <v-col cols="12">
      <installation-complete :insid="insid" @error="reportError" @skip="handleSkip" />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import InstallationComplete from './InstallationComplete'

export default {
  name: 'StepThree',
  components: {
    InstallationComplete,
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      insid: 'hosting_wp_install/insid',
      stepVal: 'hosting_wp_install/step',
    }),
    step: {
      get () {
        return this.stepVal
      },
      set (val) {
        this.setStepVal(val)
      }
    },
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
    }),
    ...mapMutations({
      setStepVal: 'hosting_wp_install/SET_STEP',
      reset: 'hosting_wp_install/RESET_STATE',
    }),
    handleSkip () {
      this.reset()
      this.setStepVal(1)
      this.$emit('collapse')
      this.$emit('set-loading', false)
    },
  },
}
</script>
